<ticketing-confirmar-gestion
  class="backModal enCalendar"
  id="confirmarGestion"
  style="display: none"
  (acepta)="actualizarAgrupadas($event)"
></ticketing-confirmar-gestion>
<div *ngIf="franjasHorario && !esReservaAgrupada()">
  <div *ngIf="currentRecinto; else cargando">
    <div class="ticket-info horarios-info">
      <div class="inputControl TicketsPasos">
        <a
          title="Previo"
          class="prev"
          (click)="prev()"
          *ngIf="!comprobarLimitePrev()"
        >
          <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
        </a>
        <span class="titulo"
          >{{ 'HorarioPara' | translateV2 }} {{ currentRecinto.NombreRecinto }}
          <span *ngIf="recintos.length > 1"
            >({{ currentRecintoIndex + 1 }} de {{ recintos.length }})</span
          ></span
        >
        <span class="resumen"
          >{{ getTotalEntradas() }} {{ ' ' }}
          {{ 'ENTRADAS' | translateV2 }}</span
        >
        <a
          title="Próximo"
          class="next"
          (click)="next()"
          *ngIf="!comprobarLimiteNext()"
        >
          <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
        </a>
      </div>
      <div class="inputControl calendar">
        <input
          type="text"
          [value]="getFechaSeleccionada()"
          (click)="openModal('datePick')"
        />
      </div>
    </div>
    <div *ngFor="let entrada of entradas; let indiceE = index">
      <div
        *ngIf="
          avanzarEntrada(
            entrada.entrada.recintos,
            entradas.length,
            entrada.entrada
          )
        "
      >
        <!--*ngIf-->
      </div>
      <div
        *ngIf="
          entrada.entrada.recintos &&
          entrada.entrada.recintos.length > 0 &&
          currentRecinto &&
          compruebaValorEnArrayRecintos(
            entrada.entrada.recintos,
            currentRecinto.Recinto
          )
        "
      >
        <!-- (entrada.entrada.recintos[0].Recinto == currentRecinto.Recinto 
        || entrada.entrada.recintos.length>1 && entrada.entrada.recintos[1].Recinto == currentRecinto.Recinto))"> -->
        <div
          class="horariosWrap"
          *ngIf="
            (!entrada.entrada.CaracteristicasEntrada ||
              entrada.entrada.CaracteristicasEntrada.length == 0) &&
            indiceE == currentEntrada
          "
        >
          <ticketing-accordion #selection>
            <!-- Habrá que hacer un bucle con los divisores de horario -->
            <ticketing-panel
              *ngFor="let franja of franjasHorario"
              title="{{ franja }}"
              [opened]="currentRecinto.sesiones[franja].length > 0"
            >
              <div *ngFor="let sesion of currentRecinto.sesiones[franja]">
                <ticketing-cell
                  *ngIf="
                    sesion.TipoAforo !== 'SD' &&
                    sesion.HoraFin &&
                    sesion.HoraFin.length > 0
                  "
                  [isSelect]="isSelected(sesion)"
                  [isRojo]="
                    sesionSobrepasaCantidadEntradasSeleccionadas(sesion)
                  "
                  [isNaranja]="getTotalEntradas() > sesion.Disponible / 2"
                  [isApagado]="sesion.disabled"
                  time="{{ sesion.HoraInicio }}"
                  ticketsLeft="({{ sesion.Disponible }}{{
                    getControlaGrupo(sesion.ControlaGrupo)
                  }})"
                  idioma="{{ sesion.IdiomaSesion }}"
                  (click)="comprobarGrupoRecintoId(sesion)"
                >
                </ticketing-cell>

                <ticketing-cell
                  *ngIf="
                    sesion.TipoAforo === 'SD' &&
                    sesion.HoraFin &&
                    sesion.HoraFin.length > 0
                  "
                  [isSelect]="isSelected(sesion)"
                  [isRojo]="
                    sesionSobrepasaCantidadEntradasSeleccionadas(sesion)
                  "
                  [isNaranja]="getTotalEntradas() > sesion.Disponible / 2"
                  [isApagado]="sesion.disabled"
                  time="{{ sesion.HoraInicio }} - {{ sesion.HoraFin }}"
                  ticketsLeft="({{ sesion.Disponible }}{{
                    getControlaGrupo(sesion.ControlaGrupo)
                  }})"
                  idioma="{{ sesion.IdiomaSesion }}"
                  (click)="comprobarGrupoRecintoId(sesion)"
                  [tipoAforo]="sesion.TipoAforo"
                >
                </ticketing-cell>
              </div>
            </ticketing-panel>
          </ticketing-accordion>
        </div>
        <div
          *ngIf="
            entrada.entrada.CaracteristicasEntrada &&
            entrada.entrada.CaracteristicasEntrada.length > 0
          "
        >
          <!--&&  mostrarSelectorEntradaConSesionxEntrada(indiceE, entrada) -->
          <div
            *ngFor="
              let caracteristica of entrada.entrada.CaracteristicasEntrada;
              let indiceC = index
            "
          >
            <div
              *ngIf="
                mostrarSelectorSesionXEntrada(entrada) &&
                mostrarSelectorSesionXCaracteristica(indiceC) &&
                mostrarSelectorEntradaConSesionxEntrada(indiceE, entrada)
              "
            >
              <!-- Añadido aqui-->
              <div class="inputControl TicketsPasos TicketsTitulo">
                <a
                  title="Previo"
                  class="prev"
                  (click)="
                    prevEntrada(entrada.entrada.CaracteristicasEntrada.length)
                  "
                  *ngIf="!comprobarLimiteEntradaPrev()"
                >
                  <img
                    class="svg"
                    src="assets/img/active-arrow.svg"
                    alt="icono prev"
                  />
                </a>
                <span class="titulo"
                  >{{ entrada.entrada.NombrePantalla }} -
                  {{ caracteristica.Tipo }} {{ caracteristica.Rango }}
                  {{ caracteristica.Nivel }}</span
                >
                <a
                  title="Próximo"
                  class="next"
                  (click)="nextEntrada(entrada.entrada.CaracteristicasEntrada)"
                  *ngIf="
                    !comprobarLimiteEntradaNext(
                      entrada.entrada.CaracteristicasEntrada
                    )
                  "
                >
                  <img
                    class="svg"
                    src="assets/img/active-arrow.svg"
                    alt="icono next"
                  />
                </a>
              </div>
              <div class="horariosWrap">
                <ticketing-accordion #selection>
                  <div
                    class="onoffswitch-wrap checked"
                    *ngIf="verGuia(entrada.entrada)"
                  >
                    <div class="onoffswitch">
                      <input
                        type="checkbox"
                        name="guiasCheck"
                        id="myguiaCheck"
                        class="onoffswitch-checkbox"
                        (change)="changeSeleccionarGuia()"
                        [checked]="seleccionarGuia"
                      />
                      <label
                        class="onoffswitch-label"
                        for="myguiaCheck"
                      ></label>
                    </div>
                    <label class="onoffswitch-label-text" for="myguiaCheck">{{
                      'SELECCIONARGUIA' | translate
                    }}</label>
                  </div>
                  <!-- Habrá que hacer un bucle con los divisores de horario -->
                  <ticketing-panel
                    *ngFor="let franja of franjasHorario"
                    title="{{ franja }}"
                    [opened]="currentRecinto.sesiones[franja].length > 0"
                  >
                    <div *ngFor="let sesion of currentRecinto.sesiones[franja]">
                      <ticketing-cell
                        *ngIf="
                          sesion.Comentarios == caracteristica.Tipo ||
                          ((!sesion.Comentarios ||
                            sesion.Comentarios.includes('/')) &&
                            sesion.filtro &&
                            sesion.filtro.nivel == caracteristica.Nivel &&
                            sesion.filtro.edad == caracteristica.Rango &&
                            sesion.filtro.modalidad == caracteristica.Tipo)
                        "
                        [isSelect]="
                          isCaracteristicaSelected(
                            sesion,
                            caracteristica,
                            indiceE
                          )
                        "
                        [isRojo]="
                          sesionSobrepasaCantidadEntradasSeleccionadas(sesion)
                        "
                        [isApagado]="sesion.disabled"
                        [isSeparadorProfesores]="true"
                        time="{{ sesion.HoraInicio }}"
                        ticketsLeft="({{ sesion.Disponible }}{{
                          getControlaGrupo(sesion.ControlaGrupo)
                        }})"
                        idioma="{{ sesion.IdiomaSesion }}"
                        (click)="
                          seleccionarSesionConCaracteristicas(
                            sesion,
                            caracteristica,
                            entrada.entrada.CaracteristicasEntrada,
                            entrada.entrada
                          )
                        "
                      >
                      </ticketing-cell>
                      <!--Inicio intento-->
                      <div
                        class="contenctProfesor"
                        *ngIf="mostrarProfe(sesion, caracteristica)"
                      >
                        <!--sesion.Comentarios ==  caracteristica.Tipo && sesionSeleccionada == sesion-->
                        <div *ngFor="let guia of sesion.Guias" class="profesor">
                          <ticketing-cell
                            [isSelect]="
                              isGuiaConCaracteristicaSelected(
                                sesion,
                                guia,
                                caracteristica,
                                indiceE
                              )
                            "
                            time="{{ guia.NombreGuia }}"
                            (click)="
                              seleccionarGuiaConCaracteristicas(
                                sesion,
                                caracteristica,
                                entrada.entrada.CaracteristicasEntrada,
                                indiceE,
                                guia
                              )
                            "
                          >
                          </ticketing-cell>
                        </div>
                      </div>
                      <!--Fin Intento-->
                    </div>
                  </ticketing-panel>
                  <!--<div
                    *ngFor="let franja of franjasHorario"
                    title="{{ franja }}"
                  >
                  <div class="row" *ngFor="let sesion of currentRecinto.sesiones[franja]">
                    <div *ngFor="let guia of sesion.Guias">
                      <ticketing-cell
                      *ngIf="sesion.Comentarios ==  caracteristica.Tipo && sesionSeleccionada == sesion"
                      [isSelect]="isCaracteristicaSelected(sesion)"
                      time="{{ guia.NombreGuia }}"
                      (click)="seleccionarSesionConCaracteristicas(sesion, caracteristica,entrada.entrada.CaracteristicasEntrada, entrada.entrada, guia )"
                    > </ticketing-cell>
                    </div>
                  </div>
                </div>-->
                </ticketing-accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <ul class="pagination">
    <li>
      <a href="#" title="Previo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev">
      </a>
    </li>
    <li><a href="#">1</a></li>
    <li><a href="#">2</a></li>
    <li><a href="#">3</a></li>
    <li><a href="#">4</a></li>
    <li><a class="active" href="#">5</a></li>
    <li><a href="#">6</a></li>
    <li>
      <a href="#" title="Próximo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono next">
      </a>
    </li>
  </ul> -->
  </div>
</div>
<div *ngIf="esReservaAgrupada()">
  <div class="aviso">
    <div class="tituloSearch">
      {{ 'RESERVA_AGRUPADA_NO_PUEDE_CAMBIAR_HORARIOS' | translate }}
    </div>
  </div>
</div>
<ng-template #cargando>
  <div class="DetalleBox__noResultsMessage">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-template>
